import { render, staticRenderFns } from "./HeaderWeShope.vue?vue&type=template&id=6ddcc134&"
import script from "./HeaderWeShope.vue?vue&type=script&lang=ts&"
export * from "./HeaderWeShope.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderWeShope.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports